import { Button, Modal } from "react-bootstrap";
import styles from "./closePop.module.scss";
import exit from "../../../assets/images/exit.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const CloseJackpotPop = ({ closePop, setClosePop, onExitConfirmed }) => {
  // const { t } = useTranslation();
  const t = useLanguage();
  const handledHide = () => {
    setClosePop(!closePop);
  };

  return (
    <>
      <Modal
        show={closePop}
        onHide={handledHide}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.closePop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body className="text-white">
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3 text-center"></div>
            <div className="py-2">
              <div
                className={`${styles.box} shadow-sm position-relative mx-auto text-center rounded-4 p-3`}
                // style={{ maxWidth: 290 }}
              >
                <div className="py-1 mb-2">
                  <img src={exit} alt="" className="img-fluid" />
                </div>
                <div>
                  <h6 className="m-0 fw-bold">{t("exitjackpot_pop.title")}</h6>
                </div>
                <div>
                  <p className="m-0 pt-1">{t("exitjackpot_pop.descp")}</p>
                </div>
              </div>
            </div>
            <div
              className={`${styles.btnWrpper} my-3 text-center gap-10 d-flex align-items-center justify-content-center`}
            >
              <Button
                // style={{ maxWidth: 130 }}
                onClick={() => setClosePop(false)}
                className="d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0"
              >
                {t("exitjackpot_pop.cancel")}
              </Button>
              <Button
                // style={{ maxWidth: 130 }}
                onClick={() => {
                  onExitConfirmed(); // call the callback
                  setClosePop(false); // close the modal
                }}
                className="d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0"
              >
                {t("exitjackpot_pop.exit")}
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default CloseJackpotPop;
